<div class="component-container">
    <!-- Navbar -->

    <nav class="navbar">
        <div class="navbar-container">
            <!-- Logo -->
            <a href="assets/price_matcher_icon.png" class="logo">
                <div class="logo-text">PRICE<span>MATCHER</span></div>
            </a>

            <!-- Desktop Navigation Links -->
            <ul class="nav-links" *ngIf="!isLoggedIn">
                <li><a [routerLink]="['/']" [class.active]="activeNavIndex === 0" (click)="toggleNav(0)">Home</a></li>
                <li><a [routerLink]="['/forgot-password']" [class.active]="activeNavIndex === 1"
                        (click)="toggleNav(1)">Forgot Password</a></li>
                <li><a [routerLink]="['/sub-pricing']" [class.active]="activeNavIndex === 2"
                        (click)="toggleNav(2)">Pricing</a></li>
                <li><a [routerLink]="['/about']" [class.active]="activeNavIndex === 3" (click)="toggleNav(3)">About</a>
                </li>
                <li><a [routerLink]="['/contact']" [class.active]="activeNavIndex === 4"
                        (click)="toggleNav(4)">Contact</a></li>
            </ul>
            <ul class="nav-links" *ngIf="isLoggedIn">
                <li><a [routerLink]="['/']" [class.active]="activeNavIndex === 0" (click)="toggleNav(0)">Home</a></li>
                <li><a [routerLink]="['/search']" [class.active]="activeNavIndex === 1"
                        (click)="toggleNav(1)">Search</a></li>
            </ul>

            <!-- Desktop Auth Buttons (Signed Out State) -->
            <div class="auth-buttons" id="authButtons" *ngIf="!isLoggedIn">
                <a class="btn btn-secondary" (click)="openLoginDialog()">Sign In</a>
                <a [routerLink]="['/register']" class="btn btn-primary">Sign Up</a>
            </div>

            <!-- Desktop User Menu (Signed In State) -->
            <div class="user-menu" id="userMenu" [style.display]="isLoggedIn ? 'block' : 'none'">

                <div class="user-avatar" id="userAvatar" (click)="toggleDropdown()">
                    <img src="assets/price_matcher_icon.png" alt="User avatar">
                </div>

                <div class="user-dropdown" id="userDropdown" [style.display]="dropdownToggle ? 'block' : 'none'">


                    <a [routerLink]="['/']" (click)="toggleDropdown()">Home</a>
                    <a [routerLink]="['/search']">Search</a>
                    <a [routerLink]="['/settings']" (click)="toggleDropdown()">Settings</a>
                    <hr>
                    <a (click)="logout(); toggleDropdown()">Sign Out</a>
                </div>
            </div>

            <!-- Mobile Hamburger Menu -->
            <div class="hamburger" id="hamburger" (click)="mobileToggleDropdown()">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </nav>

    <!-- Mobile Drawer -->
    <div class="mobile-drawer" id="mobileDrawer" [ngClass]="mobileDropdownToggle? 'open' : 'hidden'">
        <div class="drawer-header">
            <div class="logo-text">PRICE<span>MATCHER</span></div>
            <button class="drawer-close" id="drawerClose" (click)="mobileToggleDropdown()">&times;</button>
        </div>

        <!-- Mobile User Info (Signed In State) -->
        <div class="mobile-user-info" id="mobileUserInfo" *ngIf="isLoggedIn">
            <div class="mobile-user-header">
                <div class="mobile-user-avatar">
                    <img src="https://i.pravatar.cc/100" alt="User avatar">
                </div>
                <div class="mobile-user-details">
                    <h3>John Doe</h3>
                    <p>john.doe&#64;example.com</p>
                </div>
            </div>
        </div>

        <!-- Mobile Navigation Links -->
        <ul class="mobile-nav-links" *ngIf="!isLoggedIn">
            <li><a [routerLink]="['/']" [class.active]="activeNavIndex === 0"
                    (click)="toggleNav(0); mobileToggleDropdown(); openLoginDialog()">Home</a></li>
            <li><a [routerLink]="['/forgot-password']" [class.active]="activeNavIndex === 2"
                    (click)="toogleNav(2); mobileToggleDropdown()">Forgot Password</a></li>
            <li><a [routerLink]="['/sub-pricing']" [class.active]="activeNavIndex === 3"
                    (click)="toggleNav(3); mobileToggleDropdown()">Pricing</a></li>
            <li><a [routerLink]="['/about']" [class.active]="activeNavIndex === 4"
                    (click)="toggleNav(4); mobileToggleDropdown()">About</a></li>
            <li><a [routerLink]="['/contact']" [class.active]="activeNavIndex === 5"
                    (click)="toggleNav(5); mobileToggleDropdown()">Contact</a></li>
        </ul>

        <!-- Mobile Auth Buttons (Signed Out State) -->
        <div class="mobile-auth-buttons" id="mobileAuthButtons" *ngIf="!isLoggedIn">
            <a class="btn btn-secondary" (click)="mobileToggleDropdown(); openLoginDialog()">Sign In</a>
            <a [routerLink]="['/register']" class="btn btn-primary" (click)="mobileToggleDropdown()">Sign Up</a>
        </div>

        <!-- Mobile User Actions (Signed In State) -->
        <div class="mobile-auth-buttons" id="mobileUserActions" *ngIf="isLoggedIn">

            <a [routerLink]="['/']" class="btn btn-secondary" (click)="mobileToggleDropdown()">Home</a>
            <a [routerLink]="['/search']" class="btn btn-secondary" (click)="mobileToggleDropdown()">Search</a>
            <a [routerLink]="['/settings']" class="btn btn-secondary" (click)="mobileToggleDropdown()">Settings</a>
            <a (click)="logout()" class="btn btn-primary" (click)="mobileToggleDropdown()">Sign Out</a>
        </div>
    </div>

    <!-- Overlay for Mobile Drawer -->
    <div class="overlay" id="overlay"></div>

    <!-- Page Content (for demo) -->
    <div class="page-content">
        <!--
        <loading-screen *ngIf="isLoading"></loading-screen>
        -->
        <!--
        <h1>Welcome to DarkUI</h1>
        <p>This is a responsive navbar with dark theme that includes a logo, navigation links, and authentication buttons. On mobile devices, it transforms into a hamburger menu that opens a drawer with all navigation options.</p>
        <p>The navbar has two states: signed out (showing Sign In/Sign Up buttons) and signed in (showing user avatar with dropdown). You can toggle between these states using the switch at the bottom right of the page.</p>
        -->
        <router-outlet></router-outlet>
    </div>

    <!-- Demo Toggle (for demonstration purposes) 
    <div class="demo-toggle">
        <label>
            <input type="checkbox" id="signedInToggle">
            <span>Signed In: {{ isLoggedIn }}</span>
        </label>
    </div>
    -->
</div>